<template>
  <div class="teacher-class-fee">
    <van-nav-bar title="课时费" left-arrow @click-left="goBack" fixed placeholder />

    <!-- 时间段选择（默认当月1号~今天，可改） -->
    <div class="range-bar" @click="showCalendar = true">
      <van-icon name="calendar-o" size="16" color="#52C1B2" />
      <span class="range-text">{{ startDate }} ~ {{ endDate }}</span>
      <van-icon name="arrow-down" size="14" color="#999" />
    </div>

    <!-- 合计卡片 -->
    <div class="total-card">
      <div class="total-label">课时费合计</div>
      <div class="total-value">
        ¥{{ total === null ? "—" : total }}
      </div>
      <div class="total-note">数据接口待后端接入，当前为占位展示</div>
    </div>

    <!-- 明细列表（接口就绪后填充） -->
    <div class="detail-list" v-if="list.length > 0">
      <div class="detail-item" v-for="(item, index) in list" :key="index">
        <div class="detail-row">
          <span class="detail-label">日期：</span>
          <span class="detail-value">{{ item.date }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">课程/班级：</span>
          <span class="detail-value">{{ item.class_name || "未设置" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">课时费：</span>
          <span class="detail-value fee">¥{{ item.fee || 0 }}</span>
        </div>
      </div>
    </div>
    <van-empty v-else :description="emptyText" />

    <!-- 时间段范围选择弹层 -->
    <van-calendar
      v-model:show="showCalendar"
      type="range"
      :min-date="minDate"
      :max-date="maxDate"
      :default-date="rangeDates"
      @confirm="onRangeConfirm"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import api from "../service/api";

export default {
  setup() {
    const router = useRouter();

    const showCalendar = ref(false);
    const minDate = ref(new Date(new Date().getFullYear(), 0, 1)); // 今年1月1日
    const maxDate = ref(new Date()); // 今天（不可选未来）

    const startDate = ref("");
    const endDate = ref("");
    const rangeDates = ref([]); // van-calendar 用的 Date 数组

    const list = ref([]);
    const total = ref(null);
    const emptyText = ref("暂无数据");

    function formatDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    }

    // 默认时间段：当月1号 ~ 今天
    function initDefaultRange() {
      const now = new Date();
      const first = new Date(now.getFullYear(), now.getMonth(), 1);
      rangeDates.value = [first, now];
      startDate.value = formatDate(first);
      endDate.value = formatDate(now);
    }

    // 拉取课时费（接口待后端接入；失败则保持占位）
    const fetchClassFee = async () => {
      try {
        const res = await api.getTeacherClassFee({
          teacher_id: sessionStorage.getItem("userId"),
          start_date: startDate.value,
          end_date: endDate.value,
          school_id: sessionStorage.getItem("tSchoolId") || "",
          type: sessionStorage.getItem("role"),
        });
        if (res.data && res.data.code == 1001) {
          const result = res.data.result || {};
          list.value = result.list || [];
          total.value = result.total != null ? result.total : null;
          emptyText.value = "暂无数据";
        } else {
          list.value = [];
          total.value = null;
          emptyText.value = "暂无数据";
        }
      } catch (e) {
        // 后端接口尚未实现：保持占位，不抛错
        list.value = [];
        total.value = null;
        emptyText.value = "暂无数据（接口待接入）";
      }
    };

    const onRangeConfirm = (dates) => {
      showCalendar.value = false;
      if (!Array.isArray(dates) || dates.length < 2) return;
      rangeDates.value = dates;
      startDate.value = formatDate(dates[0]);
      endDate.value = formatDate(dates[1]);
      fetchClassFee();
    };

    const goBack = () => router.back();

    onMounted(() => {
      initDefaultRange();
      fetchClassFee(); // 默认按当月1号~今天查询（占位）
    });

    return {
      showCalendar,
      minDate,
      maxDate,
      startDate,
      endDate,
      rangeDates,
      list,
      total,
      emptyText,
      onRangeConfirm,
      goBack,
    };
  },
};
</script>

<style lang="less" scoped>
.teacher-class-fee {
  min-height: 100vh;
  background: #f2f2f2;
  padding-bottom: 20px;
}

.range-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px;
  padding: 12px 15px;
  background: #fff;
  border-radius: 10px;
  cursor: pointer;

  .range-text {
    flex: 1;
    font-size: 14px;
    color: #333;
  }
}

.total-card {
  margin: 10px;
  padding: 20px 15px;
  background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);
  border-radius: 10px;
  text-align: center;

  .total-label {
    font-size: 13px;
    color: #a06b1f;
  }
  .total-value {
    font-size: 28px;
    font-weight: 700;
    color: #a06b1f;
    margin: 6px 0;
  }
  .total-note {
    font-size: 11px;
    color: #bf8f4f;
  }
}

.detail-list {
  margin: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-item {
  padding: 12px;
  background: #fff;
  border-radius: 8px;
  border-left: 3px solid #ffd591;
}

.detail-row {
  display: flex;
  align-items: baseline;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.6;

  &:last-child {
    margin-bottom: 0;
  }
}

.detail-label {
  color: #666;
  width: 90px;
  flex-shrink: 0;
  font-weight: 500;
}

.detail-value {
  color: #333;
  flex: 1;

  &.fee {
    color: #a06b1f;
    font-weight: 600;
  }
}
</style>
